import { withTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"
import React from "react"
import { Icon, Modal } from "semantic-ui-react"
import ReactSVG from "react-svg"
import ShopService from "../../images/shop-service.svg"
import AppointmentCalender from "../../images/appointment-calender.svg"
import AppliedDiscounts from "../../images/applied-discounts.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCar, faCheck } from "@fortawesome/pro-regular-svg-icons"
import UberLogo from "../../images/uber_logo.svg"
import CarAdviseLogo from "../../images/CarAdvise-LogoWhite.svg"
import { faCross } from "@fortawesome/pro-light-svg-icons"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import DOMPurify from "dompurify"

const MembershipBenefitsList = ({ user, t }) => {
  const benefitsList = [
    {
      name: t("uberDiamond"),
      benefits: [
        "40% off oil changes<sup>1</sup>",
        "Get 15% off other maintenance needs, up to $50 in savings<sup>2</sup>"
      ],
      key: "diamond"
    },
    {
      name: t("uberPlatinum"),
      benefits: [
        "20% off oil changes<sup>1</sup>",
        "Get 10% off other maintenance needs, up to $50 in savings<sup>2</sup>"
      ],
      key: "platinum"
    },
    {
      name: t("uberGold"),
      benefits: ["Get 7% off all maintenance needs, up to $50 in savings<sup>2</sup>"],
      key: "gold"
    },
    {
      name: t("uberBlue"),
      benefits: ["Get 5% off all maintenance needs, up to $50 in savings<sup>2</sup>"],
      key: "blue"
    }
  ]

  return benefitsList.map((plan) => (
    <div
      className={`membership-tier-benefits-container ${
        user.affiliation_name.toLowerCase().includes(plan.key) ? "bg-red" : ""
      }`}
    >
      <div className="tier-title-container">
        <p className="tier-title">{plan.name}</p>
        {user.affiliation_name.toLowerCase().includes(plan.key) && (
          <p>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: "10px" }} />
            Your Tier
          </p>
        )}
      </div>

      {plan.benefits.map((benefit, i) => (
        <div>
          <Icon className="icon-padding color-primary" name="chevron right" />
          <SafeHtmlText text={benefit} style={{ textAlign: "left", fontSize: "medium" }} />
        </div>
      ))}
    </div>
  ))
}

const SafeHtmlText = ({ text, style }) => {
  const hasHtml = /<\/?[a-z][\s\S]*>/i.test(text)

  if (hasHtml) {
    const cleanHtml = DOMPurify.sanitize(text)
    return <span style={style} dangerouslySetInnerHTML={{ __html: cleanHtml }} />
  }

  return <span style={style}>{text}</span>
}
const UberMembershipBenefits = ({ user, isOpen, closeModal, t }) => {
  return (
    <Modal open={isOpen} className="uber-membership-benefits-modal">
      <div>
        <div style={{ textAlign: "end" }}>
          <FontAwesomeIcon icon={faClose} onClick={() => closeModal()} />
        </div>

        <p className="title">{t("membershipBenefits")}</p>

        <img src={UberLogo} className="uber-logo" alt="UberLogo" />

        <div className="booking-steps-container">
          <div className="steps-container">
            <span className="step-number">1</span>
            <ReactSVG src={ShopService} />
            <p>{t("searchForServices")}</p>
          </div>
          <div className="steps-container">
            <span className="step-number">2</span>
            <ReactSVG src={AppointmentCalender} />
            <p>{t("bookAppointment")}</p>
          </div>
          <div className="steps-container">
            <span className="step-number">3</span>
            <ReactSVG src={AppliedDiscounts} />
            <p>{t("discountsApplied")}</p>
          </div>
        </div>

        <hr />

        <div className="drive-more-container">
          <FontAwesomeIcon icon={faCar} />
          <p>{t("driveMoreWithUber")}</p>
        </div>

        <MembershipBenefitsList user={user} t={t} />

        <div className="terms-and-conditions">
          <p style={{ marginTop: "2" }}>
            <sup>1</sup> $50 cap does <b>not</b> apply to oil change perk
          </p>
          <p style={{ marginTop: "2" }}>
            <sup>2</sup> Savings subject to change.
          </p>
        </div>

        <div className="logo-container">
          <img src={CarAdviseLogo} alt="CarAdvise Logo" />
        </div>
      </div>
    </Modal>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(
  withTranslation("uberMembershipBenefits")(UberMembershipBenefits)
)
